import { SimplePageLayout, SimplePageContentWrapper, PlatformLoader } from "@flexinet/ui-components";
import { Stack, Text, Card, Group, Badge } from "@mantine/core";
import { usePaymentProfiles } from '../hooks/usePaymentProfiles';
import { PaymentProfileCard } from '../components/PaymentProfileCard';
import { IndexPageHeader } from '../components/IndexPageHeader';
import { IndexPageNavigation } from '../navigation/IndexPageNavigation';
import { useQuery } from '@tanstack/react-query';
import { fetchEnabledBillingProviders } from '../../billing-providers/services/BillingProvidersService';

export const IndexPage = () => {
    const { paymentProfiles, loading: profilesLoading, deletePaymentProfile } = usePaymentProfiles();
    
    const { data: providers, isLoading: providersLoading } = useQuery({
        queryKey: ['billing-providers'],
        queryFn: fetchEnabledBillingProviders
    });

    if (profilesLoading || providersLoading) {
        return <PlatformLoader message="Loading payment methods..." />;
    }

    return (
        <SimplePageLayout
            pageHeader={<IndexPageHeader />}
            pageNavigation={<IndexPageNavigation />}
        >
            <SimplePageContentWrapper>
                <Stack gap="lg">
                    {providers?.map((provider) => {
                        const providerProfiles = paymentProfiles.filter(
                            (profile) => profile.billingProviderId === provider.id || profile.billingProvider?.id === provider.id
                        );
                        
                        return (
                            <Card key={provider.id} withBorder p="lg">
                                <Stack gap="md">
                                    <Group justify="space-between">
                                        <Group gap="sm">
                                            <Text size="lg" fw={600}>{provider.name}</Text>
                                            <Badge color={provider.status === 'Enabled' ? 'green' : 'gray'}>
                                                {provider.status}
                                            </Badge>
                                        </Group>
                                    </Group>
                                    
                                    {providerProfiles.length > 0 ? (
                                        <Stack gap="sm">
                                            {providerProfiles.map((profile) => (
                                                <PaymentProfileCard
                                                    key={profile.id}
                                                    paymentProfile={profile}
                                                    onDelete={deletePaymentProfile}
                                                />
                                            ))}
                                        </Stack>
                                    ) : (
                                        <Text size="sm" c="dimmed">
                                            No payment methods configured for this provider.
                                        </Text>
                                    )}
                                </Stack>
                            </Card>
                        );
                    })}
                    
                    {!providers || providers.length === 0 && (
                        <Text c="dimmed" ta="center" py="xl">
                            No billing providers available.
                        </Text>
                    )}
                </Stack>
            </SimplePageContentWrapper>
        </SimplePageLayout>
    );
};
